import { sprinkles } from '@design-system/sprinkles.css';
import { ListItem } from './ListItem';
import { failedWrapper } from './VideoUploadStateModal.css';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { UploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowsRotate,
  faChevronDown,
} from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@design-system/components/button/button';

export const FailedList = ({
  failedFiles,
  dispatch,
  uploadMap,
}: Pick<UploadVideoVM, 'dispatch'> &
  Pick<UploadVideoVM['list'], 'failedFiles' | 'uploadMap'>) => {
  if (failedFiles?.length === 0) return null;

  return (
    <div className="relative">
      <Button
        variant="text"
        color="neutral"
        leftIcon={faArrowsRotate}
        className="absolute right-0 top-[10px] z-10"
        onClick={() => dispatch('reupload')}
      >
        Upload again
      </Button>
      <Accordion
        sx={{
          border: 0,
          boxShadow: 0,
          margin: 0,
          '&.MuiPaper-root:before': { content: 'none' },
          '&.MuiPaper-root.Mui-expanded': { margin: 0 },
          '&.MuiPaper-root > .MuiAccordionSummary-root': { maxWidth: 150 },
        }}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon
              icon={faChevronDown}
              className={sprinkles({ color: 'ERROR-100' })}
            />
          }
        >
          <Typography
            variant="bodyLarge"
            className={sprinkles({ color: 'ERROR-100' })}
          >
            Failed files
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className={clsx(failedWrapper)}>
            {failedFiles.map((item, index) => (
              <ListItem
                item={item}
                key={item.id}
                dispatch={dispatch}
                index={index}
                uploadState={uploadMap[item.id]}
              />
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
